import moment from "moment"

const dateFormat = "DD/MM/YYYY"

export const generateQuarterlyOptions = () => {
	const options = []
	const currentYear = moment().year()
	const currentQuarter = Math.ceil((moment().month() + 1) / 3)

	let year = currentYear
	let quarter = currentQuarter

	for (let count = 0; count < 6; count++) {
		const label = `Q${quarter} ${year}`

		let startDate, endDate

		if (quarter === 1) {
			startDate = moment(`${year}-01-01`, "YYYY-MM-DD")
			endDate = moment(`${year}-03-31`, "YYYY-MM-DD")
		} else {
			startDate = moment(`${year}-${(quarter - 1) * 3 + 1}-01`, "YYYY-MM-DD")
			endDate = moment(`${year}-${quarter * 3}`, "YYYY-MM")
				.endOf("month")
		}

		options.unshift({
			label,
			value: {
				startDate,
				endDate
			}
		})

		if (quarter === 1) {
			quarter = 4
			year--
		} else {
			quarter--
		}
	}

	return options
}

export const generateYearlyOptions = () => {
	const currentYear = moment().year()
	const options = []

	for (let year = currentYear; year >= currentYear - 5; year--) {
		const label = String(year)
		const startDate = moment([year, 0, 1])
		const endDate = moment([year, 11, 31])

		options.push({
			label,
			value: {
				startDate,
				endDate
			}
		})
	}

	return options
}
